import type { UpdateUserPayload, UserDetail } from '../entities/user.entity'
import type { UserRepository } from '../repositories/user_repository'

export class UpdateUserUseCase {
  constructor(private readonly repository: UserRepository) {}

  execute(id: string, payload: UpdateUserPayload): Promise<UserDetail> {
    return this.repository.update(id, payload)
  }
}
